import { ca } from '@cian/analytics';

/**
 * Отправка события клика на плашке описания категории.
 * https://conf.cian.tech/pages/viewpage.action?pageId=1311539818
 */
export const trackPromoCategoryPlateButtonClick = () => {
  ca('eventSite', {
    action: 'Click',
    category: 'Promo',
    label: 'info_banner',
    name: 'oldevent',
    useLastProducts: true,
  });
};
